<template>
  <div class="bg-white rounded-2xl shadow-lg border-2 border-psychology-primary-20 overflow-hidden">
    <!-- 卡片头部 -->
    <div class="bg-gradient-to-r from-psychology-primary to-psychology-secondary px-6 py-4">
      <div class="flex items-center gap-3 text-white">
        <span class="text-4xl">{{ typeData.emoji }}</span>
        <div class="flex-1">
          <h3 class="text-xl font-bold">{{ typeName }}</h3>
          <p class="text-sm opacity-90">年上年下恋爱人格类型</p>
        </div>
      </div>
    </div>

    <!-- 卡片内容 -->
    <div class="p-6 space-y-6">
      <!-- 类型描述 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-2 flex items-center gap-2">
          <span>📝</span>
          <span>类型描述</span>
        </h4>
        <p class="text-gray-700 leading-relaxed">{{ typeData.description }}</p>
      </div>

      <!-- 主要特征 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
          <span>✨</span>
          <span>主要特征</span>
        </h4>
        <div class="grid gap-2">
          <div 
            v-for="(feature, index) in typeData.features" 
            :key="index"
            class="flex items-start gap-2 p-3 bg-psychology-primary-5 rounded-lg"
          >
            <span class="text-psychology-primary mt-0.5">•</span>
            <span class="text-gray-700 text-sm">{{ feature }}</span>
          </div>
        </div>
      </div>

      <!-- 心理学解读 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-2 flex items-center gap-2">
          <span>🧠</span>
          <span>心理学解读</span>
        </h4>
        <p class="text-gray-700 leading-relaxed text-sm bg-gray-50 p-4 rounded-lg">
          {{ typeData.psychology }}
        </p>
      </div>

      <!-- 恋爱建议 -->
      <div>
        <h4 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
          <span>💡</span>
          <span>恋爱建议</span>
        </h4>
        <div class="space-y-2">
          <div 
            v-for="(advice, index) in typeData.advice" 
            :key="index"
            class="flex items-start gap-2 p-3 bg-gradient-to-r from-psychology-warm to-psychology-calm rounded-lg"
          >
            <span class="text-psychology-primary font-semibold mt-0.5">{{ index + 1 }}.</span>
            <span class="text-gray-700 text-sm">{{ advice }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RELATIONSHIP_PERSONALITY_TYPES } from '@/data/personalityTypes'

export default {
  name: 'PersonalityTypeCard',
  props: {
    typeName: {
      type: String,
      required: true
    }
  },
  computed: {
    typeData() {
      return RELATIONSHIP_PERSONALITY_TYPES[this.typeName] || {}
    }
  }
}
</script>

